import * as types from '../mutation-types'
import { FATE_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    state: {
        showTypeList: ['dayun', 'liunian', 'liuyue', 'liuri', 'liushi'],
        detailData: {},
        fateInfo: {},
        fateListData: [],
        fateSideListData: [],
        fortuneTitle: '',
        fortuneListData: [],
        fortuneSideListData: [],
        showTable: 5,
        showLabel: false,
        showTitle: false,
        showType: 'dayun',
        subTitle: '',
        curDaYun: {},
        liunianListData: [],
        liuyueListData: [],
        liuriListData: [],
        liushiListData: []
    },
    getters: {},
    mutations: {
        // 排盘页:命盘+运盘:数据操作
        [types.PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA](state, data) {
            state.detailData = data;
            state.fateInfo = data.fateInfo;
            state.fateListData = data.fateListData;
            state.showLabel = true;
            state.showTitle = true;
            state.fortuneTitle = data.fortuneTitle;
            state.fortuneListData = data.fortuneListData;
            state.detailInfoData = data.detailInfo;

            // 处理当前大运
            var resultData = data.fortuneListData.filter(ffData => {return ffData.current});
                resultData = resultData.length > 0 ? resultData : data.fortuneListData;
            state.curDaYun = resultData[0];

            // 检测到有修改之后,去掉命盘部分右边栏选中数据:并重置命盘+运盘
            if(AppFate.$store.state.editChangeBirthday){
                AppFate.$store.state.editChangeBirthday = false;
                state.showType = "dayun";
                state.subTitle = '';
                state.showTable = 5;
                state.fateSideListData.splice(0);
            }

            // 分享页面的数据
            var shareData = AppFate.$store.state.share.shareData;
            console.log('PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA-----', shareData)
            if(shareData && shareData.type && shareData.type > 2) {
                state.showLabel = false;
            }
            console.log('types.PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA------', AppFate.$store.state.editChangeBirthday, data);
        },
        [types.PLUGIN_INIT_DETAIL_FATE_SIDE_ADD](state, data) {
            var subTitle = state.subTitle;
            var originData = state.fateSideListData;
            var resultData = {}, maxLength = state.showTypeList.indexOf(data.type) + 1;

            // console.log('addd-------', state.showType, data.type, maxLength)
            
            // 特殊处理:在未点击大运的前提下点击当前大运的流年
            if(data.type == 'liunian' && originData.length == 0) {
                AppFate.$store.dispatch("detail/fatefortune/addDetailFateSide", state.curDaYun);
                subTitle = subTitle + (state.curDaYun.ganzhi + "大运");
            }

            // 检查当前:10列:是上一级别的话，就更新数据不操作dom
            if(data.type != 'liushi'){
                if(originData.length >= maxLength) {
                    resultData = FATE_DATA_MANAGER.updateFateSideData(subTitle, originData, data);
                }else{
                    resultData = FATE_DATA_MANAGER.addFateSideData(subTitle, originData, data);
                }
                state.subTitle = resultData.title;
                state.fateSideListData = resultData.data;
            }

            // 更新当前选中状态
            switch(data.type){
                case 'dayun':
                    state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, data);
                    break;
                case 'liunian':
                    state.liunianListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liunianListData, data);
                    break;
                case 'liuyue':
                    state.liuyueListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liuyueListData, data);
                    break;
                case 'liuri':
                    state.liuriListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liuriListData, data);
                    break;
                case 'liushi':
                    state.liushiListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liushiListData, data);
                    break;
                default:
                    break;
            }
            
            // 更新合化冲数据状态
            AppFate.$store.state.detail.updateRelation = true;
    
            console.log("types.DETAIL_FATE_SIDE_ADD", state.subTitle, state.fateSideListData, data)
        },
        [types.PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE](state, data) {
            var subTitle = state.subTitle;
            var originData = state.fateSideListData;
            // console.log('deeeeeeeeeeeeeeeelete------', state.showTable, data.type, state.fortuneListData, state.liunianListData)

            var resultData = FATE_DATA_MANAGER.deleteFateSideData(subTitle, originData, data);
            state.showType = resultData.type;
            state.subTitle = resultData.title;
            state.fateSideListData = resultData.data;

            // 特殊处理:十列的时候要做处理
            if(data.type == 'dayun' && state.showTable == 10) {
                state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, {id: 0})
                state.liunianListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liunianListData, {id: 0})
                AppFate.$store.dispatch('detail/fatefortune/showDetailLiuNian', state.curDaYun);
            }

            if(data.type == 'dayun' && state.showTable == 5) {
                state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, {id: 0})
            }

            // 处理神煞列表数据
            var newL = resultData.data.length + 4;
            var shenshaList = AppFate.$store.state.detail.detailShenShaList;
            AppFate.$store.state.detail.detailShenShaList.splice(newL, shenshaList.length);

            // 更新合化冲数据状态
            AppFate.$store.state.detail.updateRelation = true;
            console.log("types.DETAIL_FATE_SIDE_DELETE", state.fateSideListData)
        },
        [types.PLUGIN_CHECK_DETAIL_FORTUNE_DATA](state) {
            // 10列布局:未选中流年流月状态
            if(state.showTable == 10 && state.showType == 'dayun') {
                AppFate.$store.dispatch('detail/fatefortune/showDetailLiuNian', state.curDaYun);
            }
            
            // 5列布局:未选中流年流月状态
            if(state.showTable == 5 && state.fateSideListData.length == 0) {
                state.showType = 'dayun';
            }
            console.log('types.PLUGIN_CHECK_DETAIL_FORTUNE_DATA------', state.showType, state.showTable, state.curDaYun);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIUNIAN](state, data) {
            state.showType = "liunian";
            // 处理传入参数
            var ageStr = data.title[1];
                ageStr = ageStr.slice(0, -1);
            var yearData = {
                startAge: parseInt(ageStr),
                yearNum: data.year
            };
            state.liunianListData = FATE_DATA_MANAGER.getFortuneLiuNianDataByYear(state.fateInfo, yearData, 'detail');
            console.log("types.DETAIL_SHOW_LIUNIAN", yearData, state.liunianListData);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIUYUE](state, yearNum) {
            state.showType = "liuyue";
            state.liuyueListData = FATE_DATA_MANAGER.getFortuneLiuYueDataByYear(state.fateInfo, yearNum, 'detail');
            console.log("types.DETAIL_SHOW_LIUYUE", yearNum, state.liuyueListData);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIURI](state, yueTime) {
            state.showType = "liuri";
            state.liuriListData = FATE_DATA_MANAGER.getFortuneLiuRiDataByYear(state.fateInfo, yueTime);
            console.log("types.DETAIL_SHOW_LIURI", yueTime, state.liuriListData);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIUSHI](state, shiTime) {
            state.showType = "liushi";
            state.liushiListData = FATE_DATA_MANAGER.getFortuneLiuShiDataByYear(state.fateInfo, shiTime);
            console.log("types.DETAIL_SHOW_LIUSHI", shiTime, state.liushiListData);
        },
        [types.PLUGIN_INIT_RESET_DETAIL_FATE_FORTUNE_DATA](state) {
            // 重置数据
            state.detailData = {};
            state.fateInfo = {};
            state.fateListData = [];
            state.fateSideListData = [];
            state.fortuneTitle = '';
            state.fortuneListData = [];
            state.fortuneSideListData = [];
            state.showTable = 5;
            state.showLabel = false;
            state.showTitle = false;
            state.showType = 'dayun';
            state.subTitle = '';
            state.curDaYun = {};
            state.liunianListData = [];
            state.liuyueListData = [];
            state.liuriListData = [];
            state.liushiListData = [];
        },
    },
    actions: {
        initDetailFateFortune({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA, data);
        },
        addDetailFateSide({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_ADD, data);
        },
        deleteDetailFateSide({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE, data);
        },
        checkDetailFortuneData({ commit }) {
            commit(types.PLUGIN_CHECK_DETAIL_FORTUNE_DATA)
        },
        showDetailLiuNian({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIUNIAN, data);
        },
        showDetailLiuYue({ commit }, yearNum) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIUYUE, yearNum);
        },
        showDetailLiuRi({ commit }, yueTime) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIURI, yueTime);
        },
        showDetailLiuShi({ commit }, shiTime) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIUSHI, shiTime);
        },
        resetDetailData({ commit }) {
            commit(types.PLUGIN_INIT_RESET_DETAIL_FATE_FORTUNE_DATA)
        },
    }
}